import apiClient from './api';

export interface QueueTokenPayload {
  id: number;
  tokenLabel: string;
  tokenNumber?: number;
  status: string;
  queueType?: string;
  partySize: number;
  guestName?: string;
  position?: number;
  estimatedWaitMinutes?: number;
  publicRef?: string;
  guestStatusUrl?: string;
  createdAt?: string;
}

export interface QueueJoinRequest {
  partySize: number;
  guestName?: string;
  guestPhone: string;
  notes?: string;
  queueType?: string;
}

class QueueService {
  async joinQueue(appName: string, data: QueueJoinRequest) {
    const response = await apiClient.post(`/api/restaurants/${appName}/queue/tokens`, {
      queueType: 'DINE_IN',
      ...data,
    });
    return response.data as {
      success: boolean;
      message?: string;
      token?: QueueTokenPayload;
    };
  }

  async getStatus(appName: string, publicRef: string) {
    const response = await apiClient.get(`/api/restaurants/${appName}/queue/status/${publicRef}`);
    return response.data as {
      success: boolean;
      message?: string;
      token?: QueueTokenPayload;
    };
  }

  async cancelToken(appName: string, publicRef: string, guestPhone: string) {
    const response = await apiClient.post(
      `/api/restaurants/${appName}/queue/status/${publicRef}/cancel`,
      { guestPhone }
    );
    return response.data as {
      success: boolean;
      message?: string;
      token?: QueueTokenPayload;
    };
  }
}

export default new QueueService();
